module.exports = __webpack_public_path__ + "img/88.3bf1b0e1.jpg";